import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  resolveRopInstitutionUuidList,
  appendRopInstitutionUuidListParams,
} from 'utils/employerTalentRop';
import {
  requestTalentReadyGraphicMatrix,
  receiveTalentReadyGraphicMatrix,
  handleTalentReadyGraphicMatrixError,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.TALENT_READY_GRAPHIC_MATRIX_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.TALENT_READY_GRAPHIC_MATRIX_RECEIVE:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.TALENT_READY_GRAPHIC_MATRIX_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchTalentReadyGraphMetrics = () => (dispatch, getState) => {
  const {
    auth: {
      access = {},
      access: {token},
    },
    instance: {
      data: {institution_id},
    },
  } = getState();

  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestTalentReadyGraphicMatrix());

  let uri = `${API.administration.talent_exchange}?graph_metrics=true`;

  try {
    return resolveRopInstitutionUuidList(dispatch, getState, token)
      .then(ropList => {
        uri = appendRopInstitutionUuidListParams(uri, getState(), ropList);
        return fetch(uri, config);
      })
      .then(response => response.json())
      .then(json => {
        dispatch(receiveTalentReadyGraphicMatrix(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleTalentReadyGraphicMatrixError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleTalentReadyGraphicMatrixError(err));
  }
};
